module.exports = __webpack_public_path__ + "img/2400.57ea1f45.jpg";